import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    // Show first tab by default
    if (this.tabTargets.length > 0) {
      this.showTab(this.tabTargets[0], this.panelTargets[0])
    }
  }

  switch(event) {
    event.preventDefault()
    const clickedTab = event.currentTarget
    const panelId = clickedTab.dataset.tabPanel
    const panel = document.getElementById(panelId)
    
    // Hide all panels and deactivate all tabs
    this.tabTargets.forEach(tab => {
      tab.classList.remove('border-indigo-500', 'text-indigo-600')
      tab.classList.add('border-transparent', 'text-gray-500')
    })
    this.panelTargets.forEach(panel => panel.classList.add('hidden'))
    
    // Show selected panel and activate selected tab
    clickedTab.classList.add('border-indigo-500', 'text-indigo-600')
    clickedTab.classList.remove('border-transparent', 'text-gray-500')
    panel.classList.remove('hidden')
  }
}
